<template>
  <div class="root">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      width="24"
      viewBox="0 -960 960 960"
    >
      <path
        d="M796-121 533-384q-30 26-69.959 40.5T378-329q-108.162 0-183.081-75Q120-479 120-585t75-181q75-75 181.5-75t181 75Q632-691 632-584.85 632-542 618-502q-14 40-42 75l264 262-44 44ZM377-389q81.25 0 138.125-57.5T572-585q0-81-56.875-138.5T377-781q-82.083 0-139.542 57.5Q180-666 180-585t57.458 138.5Q294.917-389 377-389Z"
      />
    </svg>
    <input
      class="input-box"
      v-model="internalValue"
      :placeholder="text"
      @change="onChangeValue"
      v-on:keydown.enter="onKeyDown"
    />
  </div>
</template>

<script>
export default {
  name: "input-box",
  props: {
    text: { type: String },
    value: {
      type: [String, Number, Boolean],
      default: undefined,
    },
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(newVal) {
        if (this.value !== newVal) this.$emit("input", newVal);
      },
    },
  },
  methods: {
    onChangeValue(e) {
      if (e.currentTarget) this.$emit("change-value", e.currentTarget.value);
    },
    onKeyDown() {
      this.$emit("keydown", this.internalValue);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";

.root {
  display: flex;
  justify-content: center;
  position: relative;
  svg {
    position: absolute;
    left: 0.5rem;
    top: 0.5rem;
    fill: #a3a3a3;
  }
}
.input-box {
  width: 100%;
  padding: 0.5rem 2.5rem 0.5rem;
  margin: 0.25rem 0;
  box-sizing: border-box;
  background: #f5f5f5;
  border: none;
  border-radius: 100px;
  font-size: 1rem;
  &::placeholder {
    color: #a3a3a3;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Atoms/InputSearchBox.vue